import styles from "../../styles/common/Modal.module.scss";
import {IcnClose} from "../../assets/icons";

import React, {ReactNode} from "react";
import clsx from "clsx";
import ReactModal from "react-modal";

import Button from "./Button";

interface ModalProps {
  extraClassName?: string;
  modalSize?: "sm" | "md" | "lg"; // sm = 520px | md = 550px | lg = 750px
  isModalOpen: boolean;
  onCloseModal: () => void;
  hideModalHeader?: boolean;
  modalHeaderTitle?: string;
  addCloseBtn?: boolean;
  children?: ReactNode;
}

function Modal (
  {
    extraClassName,
    modalSize,
    isModalOpen,
    onCloseModal,
    hideModalHeader,
    modalHeaderTitle,
    addCloseBtn,
    children,
  }: ModalProps) {

  return (
    <ReactModal
      isOpen={isModalOpen}
      onRequestClose={onCloseModal}
      closeTimeoutMS={100}
      parentSelector={() => document.body}
      appElement={document.getElementById("root") as HTMLElement}
      portalClassName={clsx(styles.cModal, "c-modal", extraClassName && extraClassName, isModalOpen && "is-open")}
      overlayClassName={"c-modal-overlay"}
      className={clsx("c-modal-content", modalSize? modalSize : "sm", modalHeaderTitle && "with-header")}
    >
      <div className="c-modal-content-wrapper">

        {!hideModalHeader && (
          <div className="c-modal-header">
            {modalHeaderTitle && (
              <h1 className="h4">
                {modalHeaderTitle}
              </h1>
            )}

            {addCloseBtn && (
              <div className="c-modal-header-close-btn-wrapper">
                <Button
                  extraClassName="c-modal-header-close-btn"
                  title="Close"
                  btnVariant="icon"
                  btnColor="grey"
                  icon={<IcnClose/>}
                  onClick={onCloseModal}
                />
              </div>
            )}
          </div>
        )}

        <div className="c-modal-body">
          {children}
        </div>

      </div>

    </ReactModal>
  )
}
export default Modal

